import { getCartItems } from "../../cartGlobalScripts/scripts";

// Event listener for button clicks
window.addEventListener("click", async function (event) {
  try {
    if (event.target.classList.contains("cart-drawer-subtotal__btn")) {
      event.preventDefault();
      // Validate cart items before proceeding to checkout
      const canProceed = await handleCartItems();
      if (canProceed) {
        const note = document.getElementById("CartDrawerNote").value || "";
        // Redirect to checkout with the note
        window.location.href = `/checkout?note=${encodeURIComponent(note)}`;
      } else {
        console.error("Unable to proceed. Please review your cart.");
      }
    }
  } catch (error) {
    console.error("An error occurred:", error.message);
  }
});

// Function to handle cart items and validate conditions
const handleCartItems = async () => {
  try {
    const cartItems = await getCartItems();
    // Check if the cart is empty
    if (!cartItems?.items?.length) {
      console.warn("Cart is empty.");
      return false;
    }
    // Filter free products and calculate their total quantity
    const freeProductsQuantity = cartItems.items
      .filter((item) => item.final_price === 0)
      .reduce((acc, item) => acc + item.quantity, 0);
    // Check if all items are free and the total price is zero
    if (freeProductsQuantity > 0 && cartItems.total_price === 0) {
      console.warn("Cannot proceed with only free products in the cart.");
      return false;
    }
    return true;
  } catch (error) {
    console.error("Error while handling cart items:", error.message);
    return false;
  }
};

// Listen for clicks on the "Choose options" button
document.addEventListener("click", (event) => {
  const optionsButton = event.target.closest(".product-card-options-button");
  if (!optionsButton) {
    return;
  }

  event.preventDefault();

  const form = optionsButton.closest(".product-card-variant-form");

  if (!form || form.classList.contains("variant-options-open")) {
    return;
  }

  form.classList.add("variant-options-open");

  const variantSelectTemplate = form.querySelector("template");
  if (!variantSelectTemplate) {
    console.error("Could not find <template> element inside the form.", form);
    return;
  }
  const selectElement =
    variantSelectTemplate.content.firstElementChild.cloneNode(true);

  optionsButton.before(selectElement);
  selectElement.focus();

  optionsButton.type = "submit";
  optionsButton.name = "add";

  const buttonText = optionsButton.querySelector(".btn__text");
  const translatedText = optionsButton.dataset.addText;

  if (buttonText && translatedText) {
    buttonText.textContent = translatedText;
  }

  optionsButton.classList.remove("product-card-options-button");
});

document.addEventListener("change", (event) => {
  const selectElement = event.target.closest(".product-card-variant-select");

  if (!selectElement) {
    return;
  }

  const form = selectElement.closest(".product-card-variant-form");
  const variantIdInput = form.querySelector(".product-variant-id");

  variantIdInput.value = selectElement.value;
});

function updateLongestDeliveryTime() {
  let maxDeliveryDays = 0;
  let longestDeliveryString = "";
  const deliveryDisplayElement = document.getElementById(
    "longest-delivery-display"
  );

  const cartItems = document.querySelectorAll(".cart-item");

  cartItems.forEach((item) => {
    const rawMetafield = item.dataset.deliveryTime;

    if (rawMetafield && rawMetafield.trim() !== "") {
      try {
        const highEndNumber = parseInt(
          rawMetafield.split(" ")[0].split("-").pop()
        );

        if (highEndNumber > maxDeliveryDays) {
          maxDeliveryDays = highEndNumber;
          longestDeliveryString = rawMetafield;
        }
      } catch (e) {
        console.error("Could not parse delivery time:", rawMetafield, e);
      }
    }
  });

  if (deliveryDisplayElement) {
    const iconHTML = document.getElementById("hidden-delivery-icon");

    if (longestDeliveryString) {
      if (iconHTML) {
        iconHTML.style.display = "block";
      }
      const label = deliveryDisplayElement.dataset.label;
      const labelText = label || "Delivery";
      deliveryDisplayElement.textContent = `${labelText}: ${longestDeliveryString}`;

      deliveryDisplayElement.style.display = "block";
    } else {
      deliveryDisplayElement.style.display = "none";
      if (iconHTML) {
        iconHTML.style.display = "none";
      }
    }
  }
}

const cartObserverConfig = {
  childList: true,
  subtree: true,
};

const cartObserverCallback = (mutationsList, observer) => {
  updateLongestDeliveryTime();
};

const cartObserver = new MutationObserver(cartObserverCallback);

const bodyObserverConfig = { childList: true, subtree: true };

const bodyObserverCallback = (mutationsList, observer) => {
  const cartDrawer = document.querySelector(".cart-drawer__body");

  if (cartDrawer) {
    updateLongestDeliveryTime();

    observer.disconnect();

    const cartContents = cartDrawer.querySelector(".cart-drawer__content");

    if (cartContents) {
      cartObserver.observe(cartContents, cartObserverConfig);
    }
  }
};

const bodyObserver = new MutationObserver(bodyObserverCallback);
bodyObserver.observe(document.body, bodyObserverConfig);
